import { Banner as IMGBanner } from "@assets/";

export function Banner() {
  return (
    <div className="flex flex-col items-center justify-center h-10 p-3.5 border-b border-b-[#D8DCDE]">
      <img src={IMGBanner} alt="Logo" className="w-[177px] h-6" /> 
    </div>
  );
}
